import { Injectable } from '@angular/core';
import { PriceDisplayMode } from '../../shared/enums/price-display-mode.enum';
import { DisplayOptionsService } from '../../core/display-options.service';
import { DisplayOptions } from '../../core/display-options';
import { SessionData } from '../../core/session-data';
import { SessionService } from '../../core/session.service';

@Injectable({
  providedIn: 'root'
})
export class PriceDisplayService {
  private displayOptions: DisplayOptions;
  private sessionData: SessionData;

  constructor(
    private displayOptionsService: DisplayOptionsService,
    private sessionService: SessionService
  ) {
    this.displayOptions = displayOptionsService.getOptions();
    this.sessionData = sessionService.getSessionData();
  }

  public getPriceDisplayMode(): PriceDisplayMode {
    const priceDisplayMode: string = this.displayOptions.options.price_display_mode;

    return priceDisplayMode && priceDisplayMode.toLowerCase() == PriceDisplayMode.Points.toLowerCase() ?
      PriceDisplayMode.Points :
      PriceDisplayMode.Dollars;
  }

  public getConversionRate(): number {
    if (this.getPriceDisplayMode() === PriceDisplayMode.Points){
      return this.sessionData.memberInfo.pointsCurrency.carRedemptionConversionRate;
    }
    return 0;
  }

  public getCurrencyCode(): string {
    return this.displayOptions.currency_code;
  }

  public getCurrencyLabel(): string {
    return this.displayOptions.labels.points;
  }
}
